export default __webpack_public_path__ + "static/media/right-arrow-white.b82ad54c.svg";